import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";

export const TitleContainer = styled.div`
    ${mixins.setFont({ $size: 20, $weight: 500, $color: colorsPalettes.carbon[500] })};
    display: flex;
`;
